import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { Ec2InstancesPageComponent } from "./ec2-instances-page/ec2-instances-page.component";
import { Ec2InstancesService } from "./services/ec2-instances.service";
import { SharedModule } from "../shared/shared.module";

@NgModule({
  declarations: [Ec2InstancesPageComponent],
  imports: [CommonModule, RouterModule, FormsModule, SharedModule],
  providers: [Ec2InstancesService],
})
export class Ec2InstancesModule {}
